import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    loader: {
        width: '100%',
        minHeight: theme.spacing(16),
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'var(--color-gray-dark)',
        justifyContent: 'center'
    },
    buttonWrapper: {
        background: 'transparent !important',
        '&:hover': {
            backgroundColor: 'rgba(30, 30, 30, .3) !important'
        },
        color: '#339bff'
    }
}));
